<template>

	<div class="wrapper">


		<div v-show="!info" class="call" :style="{ height: height + 'px',  width: width + 'px' }">

			<div class="profile">
				<img :src="profile" alt="Berny" />
			</div>

			<span class="text">
				Berny belt...
			</span>

			<button :class="{ button, answered: answered }" :aria-label="answered ? 'Ophangen' : 'Opnemen'" @click="answer">
				<svg aria-hidden="true" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="M21.225 17.89c-.406-.24-.905-.234-1.31.006l-2.045 1.22c-.458.272-1.03.24-1.45-.088-.726-.567-1.895-1.52-2.912-2.538-1.017-1.017-1.97-2.186-2.538-2.912-.328-.42-.36-.992-.087-1.45l1.22-2.046c.24-.404.242-.907.004-1.313L9.105 3.64c-.29-.495-.87-.74-1.428-.602-.543.132-1.248.454-1.987 1.194-2.314 2.314-3.543 6.217 5.16 14.92s12.603 7.473 14.918 5.158c.74-.74 1.062-1.447 1.195-1.99.135-.56-.105-1.133-.6-1.423l-5.138-3.008z"/></svg>
			</button>

			<video v-show="answered" :class="{ show: answered }" id="bgvid" class="video" ref="video" @ended="onEnded" playsinline>
				<source v-bind:src="videoSrc" type="video/mp4">
				</video>

			</div>

			<div v-show="info && !landscape" class="info" :style="{ height: height + 'px' }">

				<svg aria-hidden="true" id="Laag_1" xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 400 400"><path class="svg" d="M145.3 168v-56c0-5.5 4.5-10 10-10h181c5.5 0 10 4.5 10 10v127.5c0 5.5-4.5 10-10 10h-95M241.2 231.5h104"/><path class="svg" d="M217.7 297.5l-154 .5c-5.5 0-10-4.5-10-10v-95c0-5.5 4.5-10 10-10l154-.5c5.5 0 10 4.5 10 10v95c0 5.5-4.4 10-10 10zM266.8 259l10.9 38.5M286.8 297.5h-45.6M206.8 297.3V183.2M71.3 297.3V183.2M62.8 236.8v6.9"/><circle fill="#FFFFFF" class="st1" cx="217.3" cy="240.2" r="4"/></svg>

				<span class="paragraph">Gebruik je tablet of laptop om de site te kunnen bekijken.</span>

			</div>

			<div v-show="landscape" class="landscape">

				<svg aria-hidden="true" id="Laag_1" xmlns="http://www.w3.org/2000/svg" width="117" height="117" viewBox="0 0 234 234"><path class="svg" d="M109.6 176H60.1c-5.5 0-10-4.5-10-10V68c0-5.5 4.5-10 10-10h49.5c5.5 0 10 4.5 10 10v98c0 5.5-4.5 10-10 10zM51.1 74.5h68M51.1 159.5h68M131.9 106.5h42c5.5 0 10 4.5 10 10V166c0 5.5-4.5 10-10 10h-42M167.4 107.5v68M130.9 59.8c17.7 0 30.5 11.6 30.5 30.5"/><path class="svg" d="M169.1 86l-7 8.5-8.5-7"/></svg>

				<span class="paragraph">Draai je scherm</span>

			</div>

		</div>

	</template>

	<script>


		export default {

			data() {

				return {

					profile: require('../../assets/images/website/mobile/profile.jpg'),
					videoSrc: process.env.VIDEO_PATH+'website/mobile1.mp4',
					answered: false,
					info: false,
					button: 'button',
					height: '',
					width: '',
					landscape: false,
					sound: new Howl({
						src: ['./static/audio/ringing1.mp3'],
						loop: true

					})

				}

			},

			mounted: function () {

				this.sound.play()

				this.height = document.documentElement.clientHeight
				this.width = document.documentElement.clientWidth

				var self = this;

				var mql = window.matchMedia("(orientation: landscape)");

				if(mql.matches) {

					self.landscape = true

				} else {

					self.landscape = false
					self.height = document.documentElement.clientHeight
					self.width = document.documentElement.clientWidth

				}

				mql.addListener(function(m) {

					if(m.matches) {

						self.landscape = true

					}

					else {

						self.landscape = false
						self.height = document.documentElement.clientHeight
						self.width = document.documentElement.clientWidth

					}

				});

			},

			methods: {

				answer() {

					this.sound.stop()
					this.sound.unload()

					if(this.answered == false) {

						this.answered = true
						this.$refs.video.play()

					} else {

						this.answered = false
						this.info = true
						this.$refs.video.pause()

					} 			

				},

				onEnded() {

					this.answered = false
					this.info = true

				}

			}


		}

	</script>

<style lang="scss" scoped>

	@import url('https://fonts.googleapis.com/css?family=Open+Sans');

.paragraph {

	line-height: 1.6;
	font-size: 16px;

}

.title {

	margin-bottom: 5px;
	margin-top: 0;

}

.call {

	position: relative;
	background: url('../../assets/images/website/mobile/bg.jpg');
	background-size: cover;
	background-repeat: no-repeat;
	width: 100vw;

}

.info {

	font-family: 'Open Sans', sans-serif;
	background: url('../../assets/images/website/mobile/bg-info.jpg');
	background-size: cover;
	background-repeat: no-repeat;
	width: 100vw;
	text-align: center;
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

}

.profile {

	width: 170px;
	height: 170px;
	margin: 0 auto;
	padding-top: 10vh;

	img {

		max-width: 100%;
		height: auto;
		border-radius: 50%;

	}

}

.text {

	font-family: 'Open Sans', sans-serif;
	margin-top: 30px;
	text-align: center;
	width: 100%;
	display: block;
	color: white;
	font-size: 28px;

}

.button {

	position: absolute;
	bottom: 10vh;
	left: 50%;
	margin-left: -35px;
	background: #89e696;
	border-radius: 50%;
	width: 70px;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
	cursor: pointer;
	border: 0;
	outline: 0;

	&:not(.answered) {
		animation :
		scaleUp 2s infinite,
		borderScale 2s infinite;

		svg {

			animation : shake 2s cubic-bezier( 0.43, 0, 0.6, 0.4 ) infinite; 

		}
	}

	

	&.answered {

		background: #ff3331;

	}

	svg {

		width: 45px;
		height: 45px;
		
	}

	svg path {

		fill: white;

	}

}

video#bgvid {

	position: fixed;
	top: 50%;
	left: 50%;
	min-width: 100%;
	min-height: 100%;
	width: auto;
	height: auto;
	z-index: -100;
	transform: translateX(-50%) translateY(-50%);
	z-index: 1;

}

.landscape {

	font-family: 'Open Sans', sans-serif;
	position: fixed;
	z-index: 3;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: url('../../assets/images/website/mobile/landscape.jpg');
	background-size: cover;
	background-repeat: no-repeat;
	display: flex;
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	overflow: hidden;

}

.svg {fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}

*::-webkit-media-controls-panel {
  display: none!important;
  -webkit-appearance: none;
}

/* Old shadow dom for play button */

*::-webkit-media-controls-play-button {
  display: none!important;
  -webkit-appearance: none;
}

/* New shadow dom for play button */

/* This one works! */

*::-webkit-media-controls-start-playback-button {
  display: none!important;
  -webkit-appearance: none;
}

// Animations

@keyframes borderScale {
	0% {
		box-shadow :
    // 0 .125em .5em #aaa,
    inset 0 0 0 3em #4ed962,
    0 0 0 0 rgba( #4ed962, .25 );
}

50% {
	box-shadow :
    // 0 .125em .5em #aaa,
    inset 0 0 0 .5em #4ed962,
    0 0 0 0 rgba( #4ed962, .25 );
}

100% {
	box-shadow :
    // 0 .125em .5em #aaa,
    inset 0 0 0 3em #4ed962,
    0 0 0 3em rgba( #4ed962, 0 );
}
}

@keyframes scaleUp {
	0% {
		transform : scale( 1 );
	}

	50% {
		transform : scale( 1.125 );
	}
	60% {
		transform : scale( 1 );
	}
}

@keyframes shake {
	0% {
		transform : translate( 0, 0 )
	}
	1.25% {
		transform : translate( -2.5%, 0 )
	}
	2.5% {
		transform : translate( 0,0 );
	}
	3.75% {
		transform : translate( 2.5%, 0 );
	}
	5% {
		transform : translate( 0, 0 );
	}
	6.25% {
		transform : translate( -5%, 0 )
	}
	7.5% {
		transform : translate( 0,0 );
	}
	8.75% {
		transform : translate( 5%, 0 );
	}
	10% {
		transform : translate( 0, 0 );
	}
	11.25% {
		transform : translate( -5%, 0 )
	}
	12.5% {
		transform : translate( 0,0 );
	}
	13.75% {
		transform : translate( 5%, 0 );
	}
	15% {
		transform : translate( 0, 0 );
	}
	16.25% {
		transform : translate( -7.5%, 0 )
	}
	17.5% {
		transform : translate( 0,0 );
	}
	18.75% {
		transform : translate( 7.5%, 0 );
	}
	20% {
		transform : translate( 0, 0 );
	}
	21.25% {
		transform : translate( -7.5%, 0 )
	}
	22.5% {
		transform : translate( 0,0 );
	}
	23.75% {
		transform : translate( 7.5%, 0 );
	}
	25% {
		transform : translate( 0, 0 );
	}
	26.25% {
		transform : translate( -7.5%, 0 )
	}
	27.5% {
		transform : translate( 0,0 );
	}
	28.75% {
		transform : translate( 7.5%, 0 );
	}
	30% {
		transform : translate( 0, 0 );
	}
	31.25% {
		transform : translate( -7.5%, 0 )
	}
	32.5% {
		transform : translate( 0,0 );
	}
	33.75% {
		transform : translate( 7.5%, 0 );
	}
	35% {
		transform : translate( 0, 0 );
	}
	36.25% {
		transform : translate( -7.5%, 0 )
	}
	37.5% {
		transform : translate( 0,0 );
	}
	38.75% {
		transform : translate( 7.5%, 0 );
	}
	40% {
		transform : translate( 0, 0 );
	}
	41.25% {
		transform : translate( -7.5%, 0 )
	}
	42.5% {
		transform : translate( 0,0 );
	}
	43.75% {
		transform : translate( 7.5%, 0 );
	}
	45% {
		transform : translate( 0, 0 );
	}
	46.25% {
		transform : translate( -7.5%, 0 )
	}
	47.5% {
		transform : translate( 0,0 );
	}
	48.75% {
		transform : translate( 7.5%, 0 );
	}
	50% {
		transform : translate( 0, 0 );
	}
}


</style>


// WEBPACK FOOTER //
// Mobile.vue?0a61b2d3